module.exports = __webpack_public_path__ + "static/img/img-main-try-logo@3x.7850662.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/img-main-try-logo@3x.png
// module id = D1KG
// module chunks = 18